import { IMultiNavRoute, ISingleNavRoute } from 'app/components/navigation/Nav/interfaces'
import * as React from 'react'
import { Label, ListGroup, ListGroupItem } from 'react-bootstrap'
import * as ReactDOM from 'react-dom'
import { Link, NavLink } from 'react-router-dom'

export interface INavItemProps {
  multiConfig?: IMultiNavRoute
  singleConfig?: ISingleNavRoute
  currentPath: string
}

export interface INavItemState {
  forceOpen: boolean
}

class NavItem extends React.Component<INavItemProps, INavItemState> {

  unlisten: () => void
  state = {
    forceOpen: undefined,
  }

  componentWillUnmount() {
    if (typeof this.unlisten === 'function') {
      this.unlisten()
    }
  }

  getListGroupClass() {
    let classes = 'list-group-item list-group-item-inner-list'
    let hasMatch = false

    if (this.state.forceOpen === false) {
      return classes
    }

    // tslint:disable-next-line:prefer-conditional-expression
    if (this.props.multiConfig) {
      hasMatch = this.props.multiConfig.routes
        .filter((r) => this.props.currentPath.indexOf(r.path) >= 0).length > 0
    } else {
      hasMatch = this.props.currentPath.indexOf(this.props.singleConfig.path) >= 0
    }

    if (hasMatch || this.state.forceOpen) {
      classes += ' open'
    }

    return classes
  }

  toggleForceOpen(e) {
    const parentElem = ReactDOM.findDOMNode(this)
    if (parentElem === e.target) {
      this.setState({ forceOpen: !this.state.forceOpen })
    }
  }

  render() {
    if (this.props.multiConfig) {
      return (
        <a className={this.getListGroupClass()} onClick={this.toggleForceOpen.bind(this)}>
          <i className={this.props.multiConfig.icon}></i>
          {this.props.multiConfig.name}

          <ListGroup className="list-group-clear">
            {this.props.multiConfig.routes.map((route, index) => (
              <NavLink key={index} exact={!!route.exact} to={route.path} className="list-group-item">
                {route.name}
              </NavLink>
            ))}
          </ListGroup>
        </a>
      )
    } else if (this.props.singleConfig) {
      const single = this.props.singleConfig

      return (
        <NavLink exact={!!single.exact} to={single.path} className="list-group-item clearfix">
          <i className={single.icon}></i>
          {single.name}
          {
            single.badgeLabel ?
              <span className="pull-right">
                <Label bsStyle={single.badgeStyle || 'success'}>{single.badgeLabel}</Label>
              </span>
              : null
          }
        </NavLink>
      )
    }
  }
}

export {
  NavItem,
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/NavItem/index.tsx